// extracted by mini-css-extract-plugin
module.exports = {"searchB":"SearchNav_searchB__36smb","header":"SearchNav_header__35Qk4","searchBox":"SearchNav_searchBox__28upX","rootSb":"SearchNav_rootSb__19zxn"};